export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-B1.e43682d3.jpg";